<div [id]="fieldName+'ganttChartWrapper'+key" class="form-group label-static">
	<mat-label class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} control-label"
             [title]="componentDefinition?.label">
    {{componentDefinition?.label}}
    </mat-label>
    <div class="gantt_control">
    	<button type="button" (click)="toggleMode($event)">Reload</button>
    </div>
    <div #elemWrp id="wrp">
	<div #elemGanttChart [id]="fieldName+'ganttchartdhtmlx'+key" class="sc-gantt-chart-dhtml" style="width:100%; height:500px;"></div>
	</div>
</div>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
